import React, { useEffect, useRef } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import {
  fetchSettlementData,fetchInvoiceDataPrint,fetchAdavanceDataPrint,
  selectReceiptData,selectSettlementInvRegDetails,selectSettlementAdvRegDetails,
  selectReceiptLoading
} from '../../Store/PHPSlice/ReceiptApi/receiptApi';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';

const SettlementPrint = () => {
  const { Id, type } = useParams();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const rcptData = useSelector(selectReceiptData);
  const advanceDetails = useSelector(selectSettlementAdvRegDetails);
  const invoiceDetails = useSelector(selectSettlementInvRegDetails);
  const loading = useSelector(selectReceiptLoading);
  const totalAmt = advanceDetails?.reduce(
  (sum, row) => sum + Number(row.amt || 0),
  0
);
const totalInvAmt = invoiceDetails?.reduce(
  (sum, row) => sum + Number(row.balAmt || 0),
  0
);

  useEffect(() => {
    dispatch(fetchSettlementData({ id: Id, type }));
    dispatch(fetchInvoiceDataPrint({ id: Id, type }));
    dispatch(fetchAdavanceDataPrint({ id: Id, type }));
  }, [Id, type, dispatch]);

  if (loading) return <p>Loading...</p>;
  if (!rcptData) return <p>No receipt data found</p>;

  const th = {
    border: '1px solid #000',
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold',
    fontSize: '12px',
    textAlign: 'center'
  };

  const td = {
    border: '1px solid #000',
    fontSize: '12px',
    textAlign: 'center'
  };

  return (
    <Grid item xs={12}>
      <Paper>
        <div ref={componentRef} style={{ padding: '20px' }}>
          {rcptData.firmId && <FirmHeaderImg firmId={rcptData.firmId} />}

          {/* HEADER */}
          <table width="100%" cellPadding="6" cellSpacing="0">
            <tbody>
              <tr>
                <td colSpan={2}>
                  <h2 style={{ textAlign: 'center', color: 'red', margin: 0 }}>
                    {rcptData.sType === 'Adv'
                      ? 'Advance Settlement'
                      : rcptData.sType === 'Rt'
                      ? 'Return Goods Settlement'
                      : ''}
                  </h2>
                </td>
              </tr>

              <tr>
                <td>
                  <b style={{ color: 'red' }}>Settlement No :</b> {rcptData.sNo}
                </td>
                <td align="right">
                  <b style={{ color: 'red' }}>Print Date :</b>{' '}
                  {new Date().toLocaleDateString('en-GB')}
                </td>
              </tr>

              <tr>
                <td>
                  <b style={{ color: 'red' }}>Party Name :</b> {rcptData.partyNm}
                </td>
                <td align="right">
                  <b style={{ color: 'red' }}>Settlement Date :</b> {rcptData.dt}
                </td>
              </tr>
            </tbody>
          </table>

          {/* DETAILS TABLES */}
          <table width="100%" cellPadding="0" cellSpacing="0" style={{ marginTop: '20px' }}>
            <tbody>
              <tr>
                {/* LEFT – ADVANCE / RETURN */}
                <td width="50%" valign="top" style={{border:"1px solid #fff" }}>
                  <table width="100%" cellPadding="6" cellSpacing="0" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th colSpan={4} style={{ ...th, backgroundColor: '#e0f2fe' }}>
                          {rcptData.sType === 'Adv'
                            ? 'Advance Receipt Details'
                            : 'Return Receipt Details'}
                        </th>
                      </tr>
                      <tr>
                        <th style={th}>Sr</th>
                        <th style={th}>Receipt No</th>
                        <th style={th}>Date</th>
                        <th style={th}>Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {advanceDetails?.map((row, i) => (
                        <tr key={i}>
                          <td style={td}>{i + 1}</td>
                          <td style={td}>{row.rcptNo}</td>
                          <td style={td}>{row.dt}</td>
                          <td style={{ ...td, textAlign: 'right' }}>{row.amt}</td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot>
                      <tr style={{ backgroundColor: '#fef9c3' }}>
                        <td colSpan={3} style={{ ...td, fontWeight: 'bold', textAlign: 'right'}}>
                          Total
                        </td>
                        <td style={{ ...td, fontWeight: 'bold', textAlign: 'right' }}>
                          {totalAmt}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </td>

                <td width="4%" style={{border:"1px solid #fff" }}></td>

                {/* RIGHT – INVOICE */}
                <td width="50%" valign="top" style={{border:"1px solid #fff" }}>
                  <table width="100%" cellPadding="6" cellSpacing="0" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th colSpan={6} style={{ ...th, backgroundColor: '#dcfce7' }}>
                          Invoice Receipt Details
                        </th>
                      </tr>
                      <tr>
                        <th style={th}>Sr</th>
                        <th style={th}>Invoice No</th>
                        <th style={th}>Date</th>
                        <th style={th}>Invoice Amt</th>
                        <th style={th}>Paid</th>
                        <th style={th}>Balance</th>
                      </tr>
                    </thead>

                    <tbody>
                      {invoiceDetails?.map((row, i) => (
                        <tr key={i}>
                          <td style={td}>{i + 1}</td>
                          <td style={td}>{row.billNo}</td>
                          <td style={td}>{row.dt}</td>
                          <td style={{ ...td, textAlign: 'right' }}>{row.netAmt}</td>
                          <td style={{ ...td, textAlign: 'right' }}>{row.rcptPaid}</td>
                          <td style={{ ...td, textAlign: 'right' }}>{row.balAmt}</td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot>
                      <tr style={{ backgroundColor: '#fef9c3' }}>
                        <td colSpan={5} style={{ ...td, fontWeight: 'bold', textAlign: 'right' }}>
                          Total
                        </td>
                        <td style={{ ...td, fontWeight: 'bold', textAlign: 'right' }}>
                          {totalInvAmt}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>

          {/* FOOTER */}
          <table width="100%" style={{ marginTop: '40px'}}>
            <tbody>
              <tr>
                <td align="right" style={{border:"1px solid #fff" }}>
                  <b>For {rcptData.fmnm}</b>
                  <br />
                  <span style={{ fontSize: '12px' }}>Authorised Signatory</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ margin: '20px' }}>
          <ReactToPrint
            trigger={() => <Button variant="contained">PRINT</Button>}
            content={() => componentRef.current}
          />
        </div>
      </Paper>
    </Grid>
  );
};

export default SettlementPrint;
